import React, { Component } from 'react';

import About from '../About';
import Contact from '../Contact';
import Header from '../Header';
import Navigation from '../Navigation';
import Photography from '../Photography';
import Resume from '../Resume';
import grayscaleInit from '../../grayscale';

import './App.css';

class App extends Component {
  componentDidMount() {
    grayscaleInit();
  }

  render() {
    return (
      <React.Fragment>
        <Navigation />
        <Header />
        <About />
        <Resume />
        <Photography />
        <Contact />
      </React.Fragment>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.js